"use strict";

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var react_1 = __importDefault(require("react"));

var react_native_router_flux_1 = require("react-native-router-flux");

var login_page_connected_1 = require("../pages/login-page/login-page.connected");

var pharmacy_management_page_connected_1 = require("../pages/pharmacy-management-page/pharmacy-management-page.connected");

var price_lookup_page_connected_1 = require("../pages/price-lookup-page/price-lookup-page.connected");

var pharmacy_pricing_screen_connected_1 = require("../pharmacy-pricing-screen/pharmacy-pricing-screen.connected");

var pricing_experience_navigator_screen_names_1 = require("./pricing-experience-navigator.screen-names");

exports.PricingExperienceNavigator = react_native_router_flux_1.Actions.create(react_1.default.createElement(react_native_router_flux_1.Scene, {
  key: "root",
  hideNavBar: true,
  backToInitial: true
}, react_1.default.createElement(react_native_router_flux_1.Scene, {
  key: pricing_experience_navigator_screen_names_1.NavigationScreenNames.loginPage,
  component: login_page_connected_1.LoginPageConnected,
  initial: true,
  type: "replace"
}), react_1.default.createElement(react_native_router_flux_1.Scene, {
  key: pricing_experience_navigator_screen_names_1.NavigationScreenNames.pharmacyPricingScreen,
  component: pharmacy_pricing_screen_connected_1.ConnectedPharmacyPricingScreen,
  type: "replace"
}), react_1.default.createElement(react_native_router_flux_1.Scene, {
  key: pricing_experience_navigator_screen_names_1.NavigationScreenNames.priceLookupPage,
  component: price_lookup_page_connected_1.PriceLookupPageConnected,
  type: "replace"
}), react_1.default.createElement(react_native_router_flux_1.Scene, {
  key: pricing_experience_navigator_screen_names_1.NavigationScreenNames.pharmacyManagementPage,
  component: pharmacy_management_page_connected_1.PharmacyManagementPageConnected,
  type: "replace"
})));